class AccountDetails {
    constructor(accountPrefixes) {
        this.reInitSelect2OnModalOpen(accountPrefixes);
        this.changeAccountPasswordFormValidation();
        this.changeAccountDetailsFormValidation();
        this.closeAccountFormValidation();
        this.closeAccount();
        if(window.location.href.indexOf('#change-password') !== -1) {
            $('#reset_account_password_modal').modal('show');
        }
    }
    reInitSelect2OnModalOpen(accountPrefixes){
        const changeAccountDetailsModal = document.getElementById('change_account_details_modal');
        changeAccountDetailsModal.addEventListener('show.bs.modal', function () {
            new PhoneNumberInput(accountPrefixes, 'change_account_details_modal');
            $('#changeAccountTimezoneSelect').select2({
                dropdownParent: $('#change_account_details_modal')
            });
        });
        changeAccountDetailsModal.addEventListener('shown.bs.modal', function () {
            new PhoneNumberInput(accountPrefixes, 'change_account_details_modal');
            $('#changeAccountTimezoneSelect').select2({
                dropdownParent: $('#change_account_details_modal')
            });
        });

    }
    changeAccountPasswordFormValidation(){
        let form = document.getElementById('frm-changeAccountPasswordForm-changeAccountPasswordForm');
        if(form){
            let submitButton = document.getElementById('change_account_password_form_submit');
            let passwordMeter = KTPasswordMeter.getInstance(form.querySelector('[data-kt-password-meter="true"]'));
            // Password input validation
            const validatePassword = function() {
                return (passwordMeter.getScore() === 100);
            };

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'CurrentPassword': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            },
                        },
                        'NewPassword': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Password has to be between 8 and 45 characters long',
                                },
                                regexp: {
                                    regexp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.])[A-Za-z\d[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.]{8,45}$/,
                                    message: 'You used a forbidden character',
                                },
                                callback: {
                                    message: 'Please enter valid password',
                                    callback: function() {
                                        return validatePassword();
                                    }
                                }
                            }
                        },
                        'ConfirmNewPassword': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                identical: {
                                    compare: function () {
                                        return form.querySelector('[name="NewPassword"]').value;
                                    },
                                    message: 'The password and its confirm are not the same',
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        })
                    }
                }
            ).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                new DismissModal('reset_account_password_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('reset_account_password_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
    initCountryAccount(){
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        let parent =  $('#change_account_details_modal');
        $('#frm-changeAccountDetailsForm-changeAccountDetailsForm select[name=CountryAccount]').select2({
            placeholder: "Select an option",
            templateSelection: optionFormat,
            templateResult: optionFormat,
            dropdownParent: parent,
        });
    }
    changeAccountDetailsFormValidation(){
        let form = document.getElementById('frm-changeAccountDetailsForm-changeAccountDetailsForm');
        if(form){
            this.changeCountry();
            this.initCountryAccount();

            let excludeVatCompanyID = function (){
                let isEu = $('#frm-changeAccountDetailsForm-changeAccountDetailsForm select[name=CountryAccount]').find(':selected').attr('isEu');
                return isEu == 0;
            }

            let submitButton = document.getElementById('change_account_details_form_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'FullName': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'First Name cannot be over 64 characters',
                                },
                            }
                        },
                        'Address': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 256,
                                    message: 'Address cannot be over 256 characters',
                                },
                            }
                        },
                        'PhoneNumber': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    min: 7,
                                    max: 15,
                                    message: 'Phone Number has to be between 7 and 15 characters long',
                                },
                                regexp: {
                                    regexp: /^[+(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\/0-9]*$/,
                                    message: 'You used a forbidden character',
                                }
                            }
                        },
                        'Country': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'CountryAccount': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'Timezone': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'CompanyName': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Company name cannot be over 45 characters',
                                }
                            }
                        },
                        'vatID': {
                            validators: {
                                stringLength: {
                                    max: 20,
                                    message: 'VAT ID cannot be over 20 characters',
                                },
                                regexp: {
                                    regexp: /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(HR)?[0-9]{11}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}[A-Z]|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]{7}[A-Z]{1,2}|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})?$/,
                                    message: 'VAT ID is invalid.',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '?do=validateVatID',
                                    data: function () {
                                        return {
                                            country: form.querySelector('select[name="CountryAccount"]').value
                                        };
                                    },
                                }
                            }
                        },
                        'companyID': {
                            validators: {
                                stringLength: {
                                    max: 8,
                                    message: 'Company ID cannot be over 8 characters',
                                },
                                regexp: {
                                    regexp: /^[0-9]+$/,
                                    message: 'Only numeric characters are allowed',
                                },
                                callback: {
                                    message: 'This field is required',
                                    callback: function(input) {
                                        let country = $('#frm-changeAccountDetailsForm-changeAccountDetailsForm select[name=CountryAccount]').find(':selected').val();
                                        if(country == 54 && form.querySelector('input[name=vatID]').value !== ''){
                                            return {
                                                valid: !!input.value
                                            };
                                        }
                                        return {
                                            valid: true
                                        };
                                    }
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                vatID: 0.5,
                            },
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        // Validate fields when clicking the Submit button
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // Submit the form when all fields are valid
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                        excluded: new FormValidation.plugins.Excluded({
                            excluded: function(field, element, elements) {
                                if(field === 'vatID' || field === 'companyID'){
                                    return excludeVatCompanyID();
                                }
                                return false;
                            }
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.attributes.name.value === 'Password' || e.element.attributes.name.value === 'Country'){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                new DismissModal('change_account_details_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('change_account_details_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
    changeCountry(){
        let vatCompanyWrapper = $('#frm-changeAccountDetailsForm-changeAccountDetailsForm #vatCompanyID_wrapper');
        const hideVatCompany = function () {
            vatCompanyWrapper.addClass('d-none');
            vatCompanyWrapper.find('input[name="vatID"]').attr('disabled', true);
            vatCompanyWrapper.find('input[name="companyID"]').attr('disabled', true);
        }
        const showVatCompany = function () {
            vatCompanyWrapper.removeClass('d-none');
            vatCompanyWrapper.find('input[name="vatID"]').attr('disabled', false);
            vatCompanyWrapper.find('input[name="companyID"]').attr('disabled', false);
        }

        $('#frm-changeAccountDetailsForm-changeAccountDetailsForm select[name=CountryAccount]').on('select2:select', function (e) {
            const isEu = e.params.data.element.attributes.isEu.value;
            if(isEu == 1){
                showVatCompany()
            } else {
                hideVatCompany();
            }
        }).on('change', function (e) {
            const optionSelected = $("option:selected", this);
            if(optionSelected.attr('isEU') == 1){
                showVatCompany()
            } else {
                hideVatCompany();
            }
        });
    }
    closeAccount(){
        let closeAccountBtn = document.getElementById('closeAccountBtn');
        let closeAccountFormModal = document.getElementById('close_account_form_modal');
        if(closeAccountBtn){
            closeAccountBtn.addEventListener('click', function (e) {
                e.preventDefault();
                if(closeAccountFormModal){
                    new bootstrap.Modal(closeAccountFormModal, {}).show();
                } else {
                    Swal.fire({
                        html: `<span class="text-center text-primary">Please cancel all your active services first or contact our support team.</span>`,
                        icon: "error",
                        iconColor: "#FF5206",
                        buttonsStyling: false,
                        showCancelButton: false,
                        confirmButtonText: "Cancel",
                        customClass: {
                            confirmButton: "btn btn-light-primary mt-0"
                        },
                    });
                }
            });
        }
    }
    closeAccountFormValidation(){
        let form = document.getElementById('frm-closeAccountForm-closeAccountForm');
        if(form){
            let submitButton = document.getElementById('close_account_form_submit');

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'CurrentPassword': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                }
                            },
                        },
                        'agree': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        })
                    }
                }
            ).on('core.form.validating', function(event) {
                new DismissModal('close_account_form_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('close_account_form_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
}
window.AccountDetails = AccountDetails;